import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import {
  Form,
  Button,
  TextInput,
  DynamicDropdown,
  FullScreenLoading,
} from "src/Components";
// Requests
import { editOrAddOptionDomain } from "src/Requests/coveredCall";
import { getBaseInstruments } from "src/Requests/Order/tradeTableRequests";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import type { IEditOrAddOptionDomain } from "src/Interfaces/coveredCall";

interface IProps {
  editValues?: IEditOrAddOptionDomain;
  onClose: () => void;
  onSuccess: () => void;
}

const AddModal: React.FC<IProps> = ({ onClose, onSuccess, editValues }) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] = React.useState(
    editValues || ({} as IEditOrAddOptionDomain),
  );

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const clickHandler = () => {
    setLoading(true);
    editOrAddOptionDomain(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-center items-center">
      {loading ? <FullScreenLoading /> : <></>}
      <Form className="!w-full  py-8 px-2 !mx-auto">
        <div className="flex flex-col gap-3">
          <div className="flex w-full items-center justify-start">
            <span className="text-sm text-gray-500 w-72">نماد</span>
            <DynamicDropdown
              dropdown={{
                name: "baseInstrumentId",
                placeholder: "نماد",
              }}
              getData={() => getBaseInstruments()}
              onChange={changeHandler}
              value={formValues?.baseInstrumentId}
            />
          </div>
          <div className="flex w-full items-center justify-start">
            <span className="text-sm text-gray-500 w-72"> نوسان پذیری</span>
            <TextInput
              label=" نوسان پذیری"
              name="volatility"
              onChange={changeHandler}
              value={formValues?.volatility?.toString() || ""}
            />
          </div>
          <div className="flex w-full items-center justify-start">
            <span className="text-sm text-gray-500 w-72"> بازده نقدی</span>
            <TextInput
              label=" بازده نقدی"
              name="dividendYield"
              onChange={changeHandler}
              value={formValues?.dividendYield?.toString() || ""}
            />
          </div>
          <div className="flex w-full items-center justify-start">
            <span className="text-sm text-gray-500 w-72">
              حداقل حجم روز قبل
            </span>
            <TextInput
              label="حداقل حجم روز قبل"
              name="minYesterdayVolume"
              onChange={changeHandler}
              value={formValues?.minYesterdayVolume?.toString() || ""}
              kind="price"
            />
          </div>
          <div className="flex w-full items-center justify-start">
            <span className="text-sm text-gray-500 w-72">
              حداقل ارزش معاملاتی روز قبل
            </span>
            <TextInput
              label="حداقل ارزش معاملاتی روز قبل"
              name="minYesterdayValue"
              onChange={changeHandler}
              value={formValues?.minYesterdayValue?.toString() || ""}
              kind="price"
            />
          </div>
        </div>
      </Form>
      <div className="mt-6 w-64 self-center">
        <Button
          // text={props.editValues ? "ویرایش" : "ثبت"}
          text="ثبت"
          onClick={clickHandler}
          variant="contained"
        />
      </div>
    </div>
  );
};

export default AddModal;
